import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';

import {
  eventListenerForType,
  hasSelectedPerformanceCookies
} from "@/lib/analytics/cookie-script";

const mixpanelToken = import.meta.env.VITE_ANALYTICS_MIXPANEL_TOKEN
let mixpanelActive = false;

type MixPanelContext = {
  event_name: string,
  properties?: mixpanel.Dict
}
export default function track(event: string | MixPanelContext, id: number | null) {
  if (!mixpanelToken || !mixpanelActive) {
    return
  }

  if (id !== null) {
    mixpanel.identify(String(id))
  }

  if (typeof event === 'string') {
    mixpanel.track(event)
  } else {
    mixpanel.track(event.event_name, event.properties)
  }
}

const initialiseMixpanel = () => {
  if (mixpanelToken && hasSelectedPerformanceCookies()) {
    mixpanel.init(mixpanelToken, {
      track_pageview: 'url-with-path',
      api_host: 'https://api-eu.mixpanel.com',
      autocapture: {
        pageview: 'url-with-path',
      },
    })

    mixpanelActive = true
  }
}

// Initialise Mixpanel when loaded (they may have already accepted previously)
initialiseMixpanel()

// Listen for if they accept performance cookies (only ever fires once per page).
eventListenerForType('performance', initialiseMixpanel)